export default "__VITE_ASSET__D4D8svUL__"